import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';

import { Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { Form, Select as SelectAntd,  Input, Spin, Radio } from 'antd';
import {  addDays } from 'date-fns';

import { IPerfil } from '@interfaces/UserComplete';
import useDebounce from '@hooks/useDebounce';
import { MaskCPFeCNPJ } from '@utils/Masks';
import {Visibility} from '@material-ui/icons';
import { LinkRoute } from '@src/Pages/Private/Cliente/shared/NovoCadastro/styles';

import UFs from '@components/Shared/BuscaEstados/UF2.json';
import InputCidades from '@components/Shared/EstadoCidadeInputs/cidades';
import InvisibleContent from '@components/Shared/InvisibleContent';

import Services, {
  IPerfils,
  IGetAllTipoIntencaoMissa,
  IRequestCreateIntencaoMissa,
  IHorarioDiaSemana,
} from './services';

interface IProps {
  idPerfil: number;
}

let nomePessoa: string;
let diaSemanaSelected: any;
let diaSemanaSelecionada: any;

const SolicitacaoIntencao: React.FC<IProps> = ({
    idPerfil,

  }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();
  const [loadingCreateIntencao, setLoadingCreateIntencao] = useState(false);
  const [loadingPerfil, setLoadingPerfil] = useState(false);
  const [loadingPessoa, setLoadingPessoa] = useState(false);

  const [checkCidade, setCheckCidade] =
  useState<any>('');
  const [checkUf, setCheckUf] = useState<any>();
  const [tipoSolicitacaoIntencaoMissa, setTipoSolicitacaoIntencaoMissa] = useState<number>(64);
  const [tiposInteracao, setTiposInteracao] = useState<IGetAllTipoIntencaoMissa[]>([]);
  const [diaSemana, setDiaSemana] = useState<IHorarioDiaSemana[]>([]);


  async function loadPessoa() {
    setLoadingPessoa(true);

    const services = new Services();
    const { error, response } = await services.GetPessoaByID(idPerfil);

    if (!error && response) {

      nomePessoa = response.nome_pessoa

      setLoadingPessoa(false);
    } else {
      console.log('error', error);
    }
  };


  async function loadPerfil() {
    setLoadingPerfil(true);
    const services = new Services();
    const { error, response } = await services.GetPerfilByID({ id: idPerfil });

    if (!error && response) {
      const perfils: IPerfils = {contato_offline: response.contato_offline,};

      setCheckCidade(perfils.contato_offline.cidade_id)
      setCheckUf(perfils.contato_offline.estado_id)

      formRef.setFieldsValue({
        estado_descricao: response.contato_offline.estado_descricao,
        cidade_id: response.contato_offline.cidade_descricao,
        contato_offline: response.contato_offline,
      });
      setLoadingPerfil(false);
    } else {
      console.log('error', error);
    }
  };

  const loadTiposInteracao = async () => {
    const services = new Services();
    const { error, response } = await services.GetAllTipoIntencao();

    if (!error && response) {
      setTiposInteracao(response);
    }
  };

  async function onSubmit(values: any) {
    setLoadingCreateIntencao(true);
    console.log(values);

    const createIntencao: IRequestCreateIntencaoMissa = {
      //horario: values.horario,
     // dia_semana: values.dia_semana,
      descricao: values.descricao,
      nome_completo: nomePessoa,
      data_intencao_missa: values.data_intencao_missa,
      id_horario_dias_semana: values.id_horario_dias_semana,
      id_perfil: idPerfil,
      id_cidade: checkCidade,
      id_estado: checkUf,
      id_tipo_solicitacao: tipoSolicitacaoIntencaoMissa,
      id_tipo_intencao_missa: values.id_tipo_intencao_missa,
    };

    const service = new Services();
    const { error, response } = await service.CreateIntencaoMissa(
      createIntencao,
    );

    //setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreateIntencao(false);
    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreateIntencao(false);
    }
  }




  const clearDataPerfil = () => {
    formRef.setFieldsValue({
      estado_descricao: '',
      cidade_id: '',
      id_perfil: '',
    });
  };

  const clearData = () => {
    formRef.setFieldsValue({
      estado_descricao: '',
      estado_id: '',
      cidade_id: '',
      id_perfil: '',
      nome: '',
      id_tipo_intencao_missa: '',
      data_intencao_missa: '',
      id_horario_dias_semana: '',
      descricao: '',
      cpf: '',
    });
  };

  const loadHorarioDiaSemana = async () => {
    const services = new Services();
    const { error, response } = await services.GetHorarioDiaSemana(diaSemanaSelecionada,);

    if (!error && response) {
      setDiaSemana(response);
    } else {
      console.log('ENTROU AQUI');
        return 0;
    }
  };

  async function pegarDiaSemana(data_intencao_missa: Date){

    const dataModificada = new Date(data_intencao_missa);
    console.log('DATA1 ', dataModificada);

    const dataExtensa = addDays(dataModificada, 1);
    console.log('DATA2 ', dataExtensa);

    const diaDaSemana = dataExtensa.getDay();
    console.log('DATA3 ', diaDaSemana);

    diaSemanaSelected = diaDaSemana;
    console.log('DATA3 ', diaSemanaSelected);

    if (diaSemanaSelected === 1){
      diaSemanaSelecionada = "Segunda-Feira";
    }else if (diaSemanaSelected === 2){
      diaSemanaSelecionada = "Terça-Feira";
    }else if (diaSemanaSelected === 3){
      diaSemanaSelecionada = "Quarta-Feira";
    }else if (diaSemanaSelected === 4){
      diaSemanaSelecionada = "Quinta-Feira";
    }else if (diaSemanaSelected === 5){
      diaSemanaSelecionada = "Sexta-Feira";
    }else if (diaSemanaSelected === 6){
      diaSemanaSelecionada = "Sábado";
    }else if (diaSemanaSelected === 0){
      diaSemanaSelecionada = "Domingo";
    }

    loadHorarioDiaSemana();
    clearDataHorario();
  };

  const clearDataHorario = () => {
    formRef.setFieldsValue({
      id_horario_dias_semana: '',
    });
  };

  useEffect(() => {
   loadTiposInteracao();
   loadPerfil();
   loadPessoa();
    window.document.title = 'CRM - Intenção';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        item
        justify="center"
        alignItems="center"
        sm={12}
        xs={12}
        style={{ marginTop: 20 }}
      >

        {/* FORMULARIO  */}
        <Grid
            container
            item
            xs={12}
            md={12}
            justify="center"
            alignItems="center"
          >
            <Spin
              size="large"
              spinning={loadingCreateIntencao}
              tip="Enviando dados..."
            >
              <Form
                form={formRef}
                scrollToFirstError={true}
                onFinish={onSubmit}
                requiredMark={false}
                style={{ width: '100%' }}
                layout="vertical"
                initialValues={{
                  estado_descricao: '',
                  cidade_id: '',
                  id_perfil: '',
                  id_tipo_intencao_missa: '',
                  data_intencao_missa: '',
                  id_horario_dias_semana: '',
                  descricao: '',
                  cpf: ''
                }}
              >



                  <Grid container item lg={10} sm={10} xs={10} style={{ padding: 10 }}>

                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={{ paddingRight: 10, paddingLeft: 10 }}
                    >
                      <Form.Item
                        label='Tipo intenção'
                        name="id_tipo_intencao_missa"
                        rules={[
                          { required: true, message: 'Campo obrigatorio' },
                        ]}
                      >
                        <SelectAntd
                          style={{ width: '100%' }}
                        >
                          {tiposInteracao.map((option, index) => (
                            <SelectAntd.Option key={option.id} value={option.id}>
                              {option.descricao}
                            </SelectAntd.Option>
                          ))}
                        </SelectAntd>
                      </Form.Item>
                    </Grid>

                    <Grid container>
                    <Grid item lg={6} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                      <Form.Item name="data_intencao_missa" label="Data agendada"
                        rules={[
                          {
                            required: true,
                            message: 'Selecione uma data agendada',
                          },
                        ]}
                      >
                          <Input type="date"  onChange={(e: any) => {pegarDiaSemana(e.target.value) }}/>
                      </Form.Item>
                    </Grid>

                    <Grid item lg={6} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                      <Form.Item name="id_horario_dias_semana" label="Horário agendado"
                          rules={[
                            {
                              required: true,
                              message: 'Selecione um horário',
                            },
                          ]}
                        >
                          <SelectAntd style={{ width: '100%' }}>
                            {diaSemana.map((option, index) => (
                              <SelectAntd.Option key={option.id} value={option.id}>
                                {option.horario}
                              </SelectAntd.Option>
                            ))}
                          </SelectAntd>
                        </Form.Item>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} xs={12} style={{ paddingRight: 10, paddingLeft: 10 }}>
                      <Form.Item
                        label='Descrição'
                        name="descricao"
                        rules={[
                          {
                            //required: true,
                            //message: 'Selecione um horário',
                          },
                        ]}
                      >
                       <Input.TextArea />
                      </Form.Item>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      item
                      md={12}
                      xs={12}
                    >
                      <Grid item md={5} xs={12} style={{ paddingTop: 10 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          onClick={clearData}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item md={1} xs={12} style={{ paddingTop: 10 }}></Grid>

                      <Grid item md={5} xs={12} style={{ paddingTop: 10 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          type="submit"
                        >
                          Solicitar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Grid>
              </Form>
            </Spin>
          </Grid>
      </Grid>
    </Grid>
  );
};

export default SolicitacaoIntencao;
